import { Input } from '@components/ui/input';
import React from 'react';

interface FullNameFieldProps {
  id: string;
  value: any;
  onChange: (value: string) => void;
  onBlur?: () => void;
  error?: string;
  disabled?: boolean;
  placeholder?: string;
  /** CSS class for the input */
  className?: string;
  /** Render in compact mode (for inline editing in accordion) */
  compact?: boolean;
}

/**
 * Standalone Full Name field component.
 * Renders a text input for entering a person's full name.
 * The initials badge is displayed by the parent FormFieldRenderer component.
 */
export const FullNameField: React.FC<FullNameFieldProps> = ({
  id,
  value,
  onChange,
  onBlur,
  error,
  disabled,
  placeholder,
  className,
  compact = false,
}) => {
  const inputClassName = compact
    ? `h-8 text-sm w-full ${error ? 'border-destructive focus-visible:ring-destructive' : ''} ${className || ''}`
    : `h-11 ${error ? 'border-destructive focus-visible:ring-destructive' : ''} ${className || ''}`;

  return (
    <Input
      id={id}
      type="text"
      value={value ?? ''}
      onChange={e => onChange(e.target.value)}
      onBlur={onBlur}
      placeholder={placeholder}
      disabled={disabled}
      className={inputClassName}
    />
  );
};
